import React from 'react';
import { useCases, useCaseLines, media } from '../data/product';
import { GuaranteeStrip, ShopHotspot } from './BannerOverlays';
export function UseCaseSection() {
  return <section aria-labelledby="usecase-heading" className="border-b border-white/10 bg-ink-950" data-id="element-874" data-mp="23dxy7anbmlvp">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-875" data-mp="1yn7r9sz8yayw">
        <h2 id="usecase-heading" className="grit-headline max-w-4xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-876" data-mp="1yl4t2lnxxbj3">
          Built for people who
          <br data-id="element-877" data-mp="28fdi2zdrimci" />
          <span className="text-grit-500" data-id="element-878" data-mp="2mcsfaqa9byf1">actually use their hands.</span>
        </h2>

        <ul className="mt-10 flex flex-wrap gap-px bg-white/10" data-id="element-879" data-mp="2mafw69srji0e">
          {useCases.map(useCase => <li key={useCase} className="flex flex-1 basis-[calc(50%-1px)] items-center justify-center bg-ink-950 px-4 py-6 text-center font-display text-xl font-extrabold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500 sm:basis-[calc(33.333%-1px)] sm:text-2xl lg:basis-[calc(20%-1px)]" data-id="element-880" data-mp="ryrg24asp9ef">
              {useCase}
            </li>)}
        </ul>

        <div className="mt-10 grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-881" data-mp="1qlsjrr1ebaf4">
          <div data-id="element-882" data-mp="1vdkgkjb5acdp">
            <ul className="space-y-1.5 font-display text-2xl font-bold uppercase leading-tight text-steel-300 sm:text-3xl" data-id="element-883" data-mp="1ve3vrs9eumo1">
              {useCaseLines.map(line => <li key={line} data-id="element-884" data-mp="25aypzyyni0wi">{line}</li>)}
            </ul>
            <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-steel-300 sm:text-lg" data-id="element-885" data-mp="2aal56dy1hr7y">
              Wherever the work takes you, X1 puts the light where your eyes already are.
            </p>
          </div>
          <figure className="relative" data-id="element-886" data-mp="fx210l9i7ado">
            <img src={media.tradesSheet} alt="Mechanics, construction, HVAC, plumbing, electrical and trucking workers wearing the GritVue X1" className="block h-auto w-full border border-white/10" data-id="element-887" data-mp="fy4t2wikbiv6" />
            <ShopHotspot box={{
            left: '82.6%',
            top: '83.4%',
            width: '16.6%',
            height: '8%'
          }} data-id="element-888" data-mp="1ia83hocpupim" />
            <GuaranteeStrip data-id="element-889" data-mp="1w9hiwlt3lflj" />
          </figure>
        </div>
      </div>
    </section>;
}